import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import axios from 'axios'
import { setToken } from '../token'

import AuthLoader from './common/AuthLoader'

const Callback = () => {
  const { isLoading, error, isAuthenticated, getAccessTokenSilently } = useAuth0()
  const history = useHistory()
  const [status, setStatus] = useState('initial')

  useEffect(() => {
    const sendTokenToBackend = async () => {
      try {
        console.log('Starting Auth0 callback...')
        const savedPlan = sessionStorage.getItem('target_plan')
        console.log('DEBUG: Plan retrieved from storage on return:', savedPlan)
        const accessToken = await getAccessTokenSilently({
          audience: process.env.AUTH0_AUDIENCE,
          scope: 'openid profile email',
        })
        setStatus('sending')
        console.log('Sending token to backend...')
        const res = await axios.post(
          `${process.env.CORPORATE_URL}/auth/token-login/`,
          { access_token: accessToken, target_plan: savedPlan },
          { withCredentials: true }
        )
        console.log('token-login res:', res.status, res.data)
        if (res.status >= 200 && res.status < 300) {
          sessionStorage.removeItem('target_plan')
          setToken(res.data.token)
          if (res.data.checkout_url) {
            setStatus('redirecting')
            console.log('Diverting to Stripe Checkout:', res.data.checkout_url)
            window.location.href = res.data.checkout_url
          } else {
            setStatus('redirecting')
            history.replace('/')
          }
        } else {
          throw new Error('Failed to log in with token')
        }
      } catch (e) {
        console.error('Failed to send token to backend', e)
        setStatus('error')
      }
    }

    if (isAuthenticated && !isLoading) {
      sendTokenToBackend()
    }
  }, [isAuthenticated, isLoading, getAccessTokenSilently, history])

  if (isLoading) return <AuthLoader />
  if (error) return <p>Oops: {error.message}</p>
  if (status === 'error') return <p>Failed to authenticate. Please try again.</p>

  return <AuthLoader />
}

export default Callback
